import { DOCUMENT, EnvironmentProviders, inject, Injectable, makeEnvironmentProviders, provideAppInitializer } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { LIB_STAGE, Stage } from '../provider'

const STAGE_PRAEFIX: Partial<Record<Stage, string>> = {
  'env-test': 'TEST',
  'env-demo': 'DEMO',
}

/**
 * Setzt auf Test und Demo die Stage vor jeden Tab-Titel („TEST · SaniUp ONE"), damit man im Tab
 * sieht, auf welchem System man gerade arbeitet. Vorne, weil ein Tab-Titel hinten abgeschnitten
 * wird. Ersetzt den `Title`-Dienst, damit auch jedes `setTitle()` einer Seite den Praefix bekommt.
 */
@Injectable()
export class StageTitle extends Title {
  private readonly praefix = STAGE_PRAEFIX[inject(LIB_STAGE)]

  constructor() {
    super(inject(DOCUMENT))
  }

  override setTitle(titel: string): void {
    const mitPraefix = this.praefix && !titel.startsWith(`${this.praefix} · `) ? `${this.praefix} · ${titel}` : titel
    super.setTitle(mitPraefix)
  }
}

export function provideStageTitle(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: Title, useClass: StageTitle },
    // Der Grundtitel aus index.html laeuft nicht ueber setTitle — einmal beim Start nachziehen.
    provideAppInitializer(() => {
      const title = inject(Title)
      title.setTitle(title.getTitle())
    }),
  ])
}
